export default __webpack_public_path__ + "static/media/fi_admin-panel.312d56d3.svg";